/* ============================================================
   NEUROVOLT — Main JS (Shopify Theme Edition)
   Uses Shopify Ajax Cart API instead of client-side cart state.
   Scroll animations, UI interactions, accordion, promo display.
   ============================================================ */

;(function () {
  'use strict';

  /* ── Toast ───────────────────────────────────────────────── */
  var toastTimer;
  function showToast(msg) {
    var toast = document.getElementById('toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      toast.className = 'toast';
      toast.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
        '<polyline points="20 6 9 17 4 12"/></svg>' +
        '<span id="toast-msg"></span>';
      document.body.appendChild(toast);
    }
    document.getElementById('toast-msg').textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  /* ── Scroll Animation ────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Sticky Nav ──────────────────────────────────────────── */
  function initNav() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav ──────────────────────────────────────────── */
  function initMobileNav() {
    var hamburger = document.querySelector('.hamburger');
    var mobileNav = document.querySelector('.mobile-nav');
    if (!hamburger || !mobileNav) return;
    var open = false;
    hamburger.addEventListener('click', function () {
      open = !open;
      if (open) {
        mobileNav.classList.add('open');
        document.body.style.overflow = 'hidden';
      } else {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        open = false;
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Quantity Selector (product page / static) ───────────── */
  function initQtySelector() {
    document.querySelectorAll('.qty-selector[data-product-qty]').forEach(function (sel) {
      var display = sel.querySelector('.qty-display');
      var hiddenInput = document.getElementById('qty-hidden');
      if (!display) return;
      sel.querySelectorAll('.qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(display.textContent) || 1;
          var delta = btn.dataset.qty === 'plus' ? 1 : -1;
          var next = Math.min(10, Math.max(1, current + delta));
          display.textContent = next;
          sel.dataset.value = next;
          if (hiddenInput) hiddenInput.value = next;
        });
      });
    });
  }

  /* ── Accordion ───────────────────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.accordion-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var item = header.closest('.accordion-item');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.accordion-item').forEach(function (i) {
          i.classList.remove('open');
          var h = i.querySelector('.accordion-header');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          header.setAttribute('aria-expanded', 'true');
        }
      });
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          header.click();
        }
      });
    });
  }

  /* ── Shopify Ajax Cart Count ─────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var count = data.item_count || 0;
        document.querySelectorAll('.cart-badge').forEach(function (el) {
          el.textContent = count;
          el.classList.toggle('visible', count > 0);
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
        });
      })
      .catch(function () {});
  }

  /* ── Add to Cart (Shopify Ajax) ──────────────────────────────
     Reads ALL enabled form fields via FormData so that selling_plan
     (subscriptions), line-item properties, and any future fields are
     submitted to Shopify, not just id+quantity.
     ─────────────────────────────────────────────────────────── */
  function buildCartAddPayload(form) {
    var payload = {};
    var properties = {};
    var fd = new FormData(form);          // FormData skips disabled inputs automatically
    fd.forEach(function (value, key) {
      if (value === '' || value == null) return;
      if (key === 'id') {
        payload.id = value;
      } else if (key === 'quantity') {
        var n = parseInt(value, 10);
        payload.quantity = isNaN(n) ? 1 : n;
      } else if (key === 'selling_plan') {
        payload.selling_plan = value;
      } else if (key.indexOf('properties[') === 0 && key.charAt(key.length - 1) === ']') {
        properties[key.slice(11, -1)] = value;
      } else {
        payload[key] = value;
      }
    });
    if (Object.keys(properties).length > 0) payload.properties = properties;
    if (!payload.quantity) payload.quantity = 1;
    return payload;
  }

  function initATC() {
    document.querySelectorAll('#product-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var labelEl = btn ? btn.querySelector('#atc-label') : null;
        var variantId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
        if (!variantId) {
          // No variant ID set yet — fall back to native submit
          form.submit();
          return;
        }
        // Cache the current label text so we can restore it after the request
        // (don't touch button innerHTML — that would destroy the #atc-label span
        // that the product-main inline script holds a reference to)
        var originalLabel = labelEl ? labelEl.textContent : null;
        
        if (btn) btn.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(buildCartAddPayload(form))
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () {
            updateCartCount();
            showToast('Added to cart!');
            if (btn) btn.disabled = false;
            if (labelEl && originalLabel != null) labelEl.textContent = originalLabel;
          })
          .catch(function (err) {
            if (btn) btn.disabled = false;
            if (labelEl && originalLabel != null) labelEl.textContent = originalLabel;
            var msg = (err && err.description) ? err.description
                    : (err && err.message)     ? err.message
                    : 'Could not add to cart. Please try again.';
            showToast(msg);
          });
      });
    });
  }

  /* ── Product image thumbnail switcher ───────────────────── */
  function initThumbs() {
    document.querySelectorAll('.thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = thumb.dataset.src;
        var mainImg = document.getElementById('main-product-img');
        if (mainImg && newSrc) {
          mainImg.style.transition = 'opacity 0.16s ease';
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = newSrc;
            mainImg.style.opacity = '1';
          }, 160);
        }
        document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount();
    initNav();
    initMobileNav();
    initQtySelector();
    initATC();
    initAccordion();
    initReveal();
    initThumbs();
  });

})();
